import React, {useEffect, useState} from 'react';
import {
  DropdownItem,
  DropdownMenu,
  DropdownToggle,
  Nav,
  // @ts-ignore
} from 'reactstrap';

import aIcon from "../../assets/img/brand/userIcons/a.svg";
import bIcon from '../../assets/img/brand/userIcons/b.svg';
import cIcon from '../../assets/img/brand/userIcons/c.svg';
import dIcon from '../../assets/img/brand/userIcons/d.svg';
import eIcon from '../../assets/img/brand/userIcons/e.svg';
import fIcon from '../../assets/img/brand/userIcons/f.svg';
import gIcon from '../../assets/img/brand/userIcons/g.svg';
import hIcon from '../../assets/img/brand/userIcons/h.svg';
import iIcon from '../../assets/img/brand/userIcons/i.svg';
import jIcon from '../../assets/img/brand/userIcons/j.svg';
import kIcon from '../../assets/img/brand/userIcons/k.svg';
import lIcon from '../../assets/img/brand/userIcons/l.svg';
import mIcon from '../../assets/img/brand/userIcons/m.svg';
import nIcon from '../../assets/img/brand/userIcons/n.svg';
import oIcon from '../../assets/img/brand/userIcons/o.svg';
import pIcon from '../../assets/img/brand/userIcons/p.svg';
import qIcon from '../../assets/img/brand/userIcons/q.svg';
import rIcon from '../../assets/img/brand/userIcons/r.svg';
import sIcon from '../../assets/img/brand/userIcons/s.svg';
import tIcon from '../../assets/img/brand/userIcons/t.svg';
import uIcon from '../../assets/img/brand/userIcons/u.svg';
import vIcon from '../../assets/img/brand/userIcons/v.svg';
import wIcon from '../../assets/img/brand/userIcons/w.svg';
import xIcon from '../../assets/img/brand/userIcons/x.svg';
import yIcon from '../../assets/img/brand/userIcons/y.svg';
import zIcon from '../../assets/img/brand/userIcons/z.svg';

// @ts-ignore
import { AppHeaderDropdown, AppNavbarBrand, AppSidebarToggler } from '@coreui/react';
import versayLogo from '../../assets/img/brand/versay_white_logo.png';
import centuryLinkLogo from '../../assets/img/brand/altLogo.png';

import "./DefaultLayout.scss";
import {useSelector} from "react-redux";
import {RootState} from "../../redux/store";
import {authenticationService} from "../../services/authentication";

function HydraHeader() {
  const portalUser: any = useSelector((state: RootState) => state.authentication.user);

  const [isLogoShown, setIsLogoShown] = useState<boolean>(true);
  const [iconSource, setIconSource] = useState<string>();

  useEffect(() => {
    setIconSource(determineLogo(portalUser?.firstName));
  }, [portalUser?.firstName]);

  function determineLogo(name?: string) {
    if (!name) {
      return aIcon;
    }

    switch(name.charAt(0).toLowerCase()){
      case "a": return aIcon;
      case "b": return bIcon;
      case "c": return cIcon;
      case "d": return dIcon;
      case "e": return eIcon;
      case "f": return fIcon;
      case "g": return gIcon;
      case "h": return hIcon;
      case "i": return iIcon;
      case "j": return jIcon;
      case "k": return kIcon;
      case "l": return lIcon;
      case "m": return mIcon;
      case "n": return nIcon;
      case "o": return oIcon;
      case "p": return pIcon;
      case "q": return qIcon;
      case "r": return rIcon;
      case "s": return sIcon;
      case "t": return tIcon;
      case "u": return uIcon;
      case "v": return vIcon;
      case "w": return wIcon;
      case "x": return xIcon;
      case "y": return yIcon;
      default: return zIcon;
    }
  }

  function handleToggleLogo(event: any) {
    if (event.shiftKey)
      setIsLogoShown((o) => !o);
  }

  function handleLogout() {
    authenticationService.logout();
  }

  return (
    <>
      <AppSidebarToggler className={'d-lg-none navbar-toggler-icon'} display={'md'} mobile />
      <AppNavbarBrand onDoubleClick={handleToggleLogo}>
        <img className={'app-navbar-brand'} src={isLogoShown ? versayLogo : centuryLinkLogo} alt={'logo'} />
      </AppNavbarBrand>
      <AppSidebarToggler className={'d-md-down-none navbar-toggler-icon'} display={'lg'} />
      <Nav className={'ml-auto'} navbar>
        <AppHeaderDropdown direction={'down'}>
          <DropdownToggle nav>
            <img src={iconSource} alt={'User Icon'} style={{ height: '42px', width: '37px', marginRight: '1.5rem' }}/>
          </DropdownToggle>
          <DropdownMenu right className={'dropdown-menu'}>
            <DropdownItem href={'#/resetPassword'}>
              <i className={'fa fa-lock'} />
              Reset Password
            </DropdownItem>
            <DropdownItem onClick={handleLogout}>
              <i className={'fa fa-power-off'} />
              Logout
            </DropdownItem>
          </DropdownMenu>
        </AppHeaderDropdown>
      </Nav>
    </>
  )
}

export default HydraHeader;
